export default __webpack_public_path__ + "static/media/zksync.e0094ab9.svg";